import { Link } from "react-router-dom"

const VehicleLink = ({ vehicle, name, className = "", newTab = false }) => {
  const stockId = vehicle?.stock_id || vehicle?.full_chassis
  const label = name || "-"

  if (!stockId) {
    return <span className={className}>{label}</span>
  }

  const href = `/stock-list/${stockId}/view`

  if (newTab) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className={`text-decoration-none text-primary ${className}`.trim()}
      >
        {label}
      </a>
    )
  }

  return (
    <Link
      to={href}
      className={`text-decoration-none text-primary ${className}`.trim()}
    >
      {label}
    </Link>
  )
}

export default VehicleLink